/**
 * Created by Administrador on 17/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenueProductionConnectionsSsr',{
                parent: 'app',
                url: '/revenueProductionConnectionsSsr?departureDate&classificationSsrId',
                params: {
                    departureDate: null,
                    classificationSsrId: "0"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProductionConnectionSsr/revenueProductionConnectionsSsr.html',
                        controller: 'revenueProductionConnectionSsrCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('revenueProductionConnectionsSsr')
                            }],
                            ssrS: ['itineraryService', function(itineraryService){
                                return itineraryService.getSsrS(false);
                            }],
                            classifications: ['classificationSsrService','$stateParams', function(classificationSsrService,$stateParams){
                                return classificationSsrService.getClassificationListSsr();
                            }],
                            'connections' : ['specialConnectionService','$stateParams',
                                function(specialConnectionService, $stateParams){
                                    if ($stateParams.departureDate == null) {
                                        $stateParams.departureDate = (new Date()).getTime();
                                    }
                                    return specialConnectionService.getConnectionsSsr(parseInt($stateParams.departureDate), $stateParams.classificationSsrId);
                            }]
                        }
                    }
                }
            })
    }
})();


